import React, { Component } from "react";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
export default class Tabel extends Component {
  render() {
    const { sensor, gastverbruik } = this.props;
    function priceFormatter(cell, row) {
      return moment(cell).format("DD-MM-YYYY");
    }

    const columns = [
      {
        dataField: "datum",
        text: "Datum",
        formatter: priceFormatter,
      },
      {
        dataField: "value",
        text: "Verbruik( kWh)",
        formatter: (cellContent, row) => {
          if (cellContent) {
            return cellContent.toFixed(2);
          } else {
            return null;
          }
        },
      },

    ];
    return <BootstrapTable wrapperClasses="table-responsive-md" keyField="datum" data={sensor.data} columns={columns} pagination={paginationFactory()} />;
  }
}


